export default __webpack_public_path__ + "static/media/link1.78bb5ff5.png";